export default __webpack_public_path__ + "media/images/icons_ns8-214c789e65ea56634da002608eda7ac0.png";